import { render, staticRenderFns } from "./ifizxfg.vue?vue&type=template&id=220ca23f&scoped=true&"
import script from "./ifizxfg.vue?vue&type=script&lang=js&"
export * from "./ifizxfg.vue?vue&type=script&lang=js&"
import style0 from "./ifizxfg.vue?vue&type=style&index=0&id=220ca23f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ca23f",
  null
  
)

export default component.exports